import { createWebhooksApi } from './webhooks/index';
import { createApiKeysApi } from './api-keys/index';
import { createEmailTemplatesApi } from './email-templates/index';
import { createMailboxesApi } from './mailboxes/index';
import { createAccountSettingsApi } from './account/index';
import { createDesignApi } from './helpcenter/design/index';
import { createTextsApi } from './helpcenter/texts/index';
import { createFeaturedArticlesApi } from './helpcenter/featured-articles/index';
import { createDomainApi } from './helpcenter/domain/index';
import { createHelpcenterContactApi } from './helpcenter/contact/index';
import { createCustomCssApi } from './helpcenter/custom-css/index';
import { createCustomJsApi } from './helpcenter/custom-js/index';
import { createAuthSettingsApi } from './helpcenter/authentication/index';
import { createSeoApi } from './helpcenter/seo/index';
import { createContentVisibilityApi } from './helpcenter/content-visibility/index';
import { createCustomHeadCodeApi } from './helpcenter/custom-head-code/index';
import { createHeaderFooterSettingsApi } from './helpcenter/header-footer/index';
import { createAppSettingsApi } from './app/index';
import { createCallcenterSettingsApi } from './callcenter/index';
import { createRuleEngineApi } from './rule-engine';
import { createEmailDomainApi } from './email-notification';
import { createAutoAssignApi } from './auto-assign';
import { createStructureAndContentApi } from './helpcenter/structure-and-content';
import { createBrandingApi } from './helpcenter/branding';
import { createCsatSettingsApi } from './csat-settings';
import { createAutoRoutingApi } from './auto-routing';
import { createHelpCenterAccountApi } from './helpcenter';
import { createInAppNotificationsApi } from './in-app-notification';
import { createEscalationTemplatesApi } from './escalationTemplates';
export var createSettingsApi = function (baseUrl, http) {
    var settingsUrl = "".concat(baseUrl, "/settings");
    return {
        app: createAppSettingsApi(settingsUrl, http),
        mailboxes: createMailboxesApi(settingsUrl, http),
        account: createAccountSettingsApi(settingsUrl, http),
        inAppNotifications: createInAppNotificationsApi(settingsUrl, http),
        tools: {
            apiKeys: createApiKeysApi(settingsUrl, http),
            webhooks: createWebhooksApi(settingsUrl, http),
            emailTemplates: createEmailTemplatesApi(settingsUrl, http),
            escalationTemplates: createEscalationTemplatesApi(settingsUrl, http),
            emailDomain: createEmailDomainApi(settingsUrl, http)
        },
        helpcenter: {
            structureAndContent: createStructureAndContentApi(settingsUrl, http),
            branding: createBrandingApi(settingsUrl, http),
            seo: createSeoApi(settingsUrl, http),
            design: createDesignApi(settingsUrl, http),
            texts: createTextsApi(settingsUrl, http),
            featuredArticles: createFeaturedArticlesApi(settingsUrl, http),
            domain: createDomainApi(settingsUrl, http),
            contact: createHelpcenterContactApi(settingsUrl, http),
            customCss: createCustomCssApi(settingsUrl, http),
            customJs: createCustomJsApi(settingsUrl, http),
            customHeadCode: createCustomHeadCodeApi(settingsUrl, http),
            headerFooter: createHeaderFooterSettingsApi(settingsUrl, http),
            auth: createAuthSettingsApi(settingsUrl, http),
            contentVisibility: createContentVisibilityApi(settingsUrl, http),
            account: createHelpCenterAccountApi(settingsUrl, http)
        },
        callcenter: createCallcenterSettingsApi(settingsUrl, http),
        rulesEngine: createRuleEngineApi(baseUrl, http),
        autoAssign: createAutoAssignApi(settingsUrl, http),
        autoRouting: createAutoRoutingApi(settingsUrl, http),
        csat: createCsatSettingsApi(settingsUrl, http)
    };
};
export * from './account';
export * from './api-keys';
export * from './app';
export * from './auto-assign';
export * from './auto-routing';
export * from './callcenter';
export * from './csat-settings';
export * from './email-notification';
export * from './email-templates';
export * from './helpcenter';
export * from './mailboxes';
export * from './rule-engine';
export * from './webhooks';
export * from './domain';
export * from './escalationTemplates';
//# sourceMappingURL=index.js.map